var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"rkm-navbar-nav-icon",attrs:{"pill":""},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('rkm-icon',{attrs:{"icon":"bars"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }